import { Link } from 'react-router-dom';
import styles from './Index.module.css';

const SupportCard = ({
    emoji, title, text, urlLearnMore, target
}) => {
    return <section className={styles.ContainerSupportCard}>
        <p className={styles.EmojiSupportCard}>{emoji}</p>
        <b>{title}</b>
        <p className={styles.TextSupportCard}>{text}</p>
        <b><Link to={urlLearnMore} target={target}>Saiba mais</Link></b>
    </section>
}



export const EstablishmentCards = () => {
    return <section className={styles.ContainerEstablishmentCards}>

        <hr />
        <SupportCard
            emoji={'🏆'}
            title={'Seja um apoiador ou patrocine o desenvolvimento do Tô no Mercado.'}
            text={'Ao apoiar o TooMe, você estará contribuindo para o crescimento de diversas funcionalidades e vantagens que trarão benefícios para o seu dia a dia de compras no supermercado.'}
            urlLearnMore={'/opc_gerais/crescer/'}
        />
        <hr />
        <SupportCard
            emoji={'🚀'}
            title={'Para você, que é um estabelecimento e quer saber as vantagens de ser parceiro.'}
            text={'Somos uma plataforma inteligente de consumo e inteligência de mercado voltada ao varejo alimentar, desenvolvida para conectar consumidores, supermercados e inteligência de dados.'}
            urlLearnMore={'/opc_gerais/estabelecimentos/'}
        />
        <hr />
        <SupportCard
            emoji={'📢'}
            title={'Quer anunciar no TooMe? fale diretamente conosco e saiba como!'}
            urlLearnMore={'https://api.whatsapp.com/send?phone=45988191601'}
            target={'_blank'}
        />
        <hr />

    </section>
}